import { render } from "./ChatbotView.vue?vue&type=template&id=9797d96e&scoped=true"
import script from "./ChatbotView.vue?vue&type=script&lang=js"
export * from "./ChatbotView.vue?vue&type=script&lang=js"

import "./ChatbotView.vue?vue&type=style&index=0&id=9797d96e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9797d96e"]])

export default __exports__